module.exports = __webpack_public_path__ + "img/eth-circle-logo.d5f5afce.svg";